module.exports = __webpack_public_path__ + "f33b077fc6afdbdb234b5228d5417344.pdf";